import { render, staticRenderFns } from "./ClosingReasonsBarChart.vue?vue&type=template&id=4c9667d8&scoped=true&"
import script from "./ClosingReasonsBarChart.vue?vue&type=script&lang=js&"
export * from "./ClosingReasonsBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ClosingReasonsBarChart.vue?vue&type=style&index=0&id=4c9667d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9667d8",
  null
  
)

export default component.exports